import { useEffect, useState } from 'react';
import { useFormik } from 'formik';
import { initialValues } from './formData';
import { RedirectParams } from '../../../../../shared/types/redirectParams';
import { ISelect, ParamEnum } from '../../../../../shared/types/shared';
import { asyncGetParams } from '../../../../../services/param.service';

export const useRedirectPqrFilters = (
    onFilter?: (data: RedirectParams) => void
) => {
    const [areas, setAreas] = useState<ISelect[]>([]);

    const onSubmit = (data: RedirectParams) => {
        if (onFilter) onFilter(data || {});
    };

    const formik = useFormik({
        initialValues: {
            ...initialValues,
            name: '',
            extra: '',
            parent: '',
            active: true,
        },
        onSubmit,
    });
    useEffect(() => {
        asyncGetParams(ParamEnum.PQR_REDIRECTION_AREA).then((items) =>
            setAreas(items)
        );
    }, []);

    return {
        formik,
        areas,
    };
};
